module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hans_hokkaido-73fb8e30bd8ac6c037c409a374dcea6f.jpg";